// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__3PmkM","withHover":"styles_withHover__2nUcN"};